import { IRevenueSpendByAccountSpendDetailsTableLang } from '../../../types/lang'

export const revenueSpendByAccountSpendDetailsTableLang: IRevenueSpendByAccountSpendDetailsTableLang = {
	revenue_spend_by_account_spend_details_table: {
		column_id: 'ID_ru',
		column_date: 'Date_ru',
		column_amount: 'Amount_ru',
		column_percent: 'Percent, %_ru',
		column_account: 'Account_ru',
		column_kt_group: 'KT Group_ru',
		column_agency: 'Agency_ru',
		column_fake_type: 'Fake Type_ru'
	}
}